/**
 * Warehouse Details
 */

// React
import React, { useEffect, useContext, useState } from 'react';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import {
  getSkuInventoryWithIdAction, getSkusInventoryFinalizedSumActions,
  getSkusInventoryNotFinalizedSumActions,
} from '../warehouses/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectSkusInventory,
  makeSelectSkusInventoryCount,
  makeSelectAvailableCount,
  makeSelectOnWayCount,
  makeSelectReturnedCount,
} from '../warehouses/selectors';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  Button,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';

// Component
import ListSkuInventoryDetails from './components/listSkuInventoryDetails';

// Helper
import { removeEmptyValueObject } from '../../utils/helpers';

// Type
import {
  PropsSkusInventoryDetails,
  SelectorPropsSkusInventoryDetails,
} from './interfaces';
import { useParams } from 'react-router-dom';
import useQuery from '../../utils/hook/useQuery';
import RonadIcons from '../../components/iconComponent';

type Inputs = {
  'name.contains': string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
      "& #showFilter .MuiInput-underline::before, & #showFilter .MuiInput-underline::after": {
        borderBottom: '2px solid #DFA01F !important',
      }
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
    },
    showCount: {
      "& .MuiSelect-icon": {
        color: "#DFA01F",
      },
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      padding: '10px 0',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      position: 'relative',
      marginRight: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    returnButton: {
      margin: '40px 0 36px',
      padding: 0,
    },
    boxes: {
      marginBottom: '20px',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    box: {
      display: 'flex',
      backgroundColor: '#fff',
      padding: theme.spacing(3, 4),
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    boxIcon: {
      // display: 'flex',
      // alignItems: 'center',
      marginRight: '30px',
    },
    allCenter: {
      position: 'relative',
      marginRight: '40px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#696969',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '40px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },
    diactiveCenter: {
      position: 'relative',
      marginRight: '40px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#fd8686',
      },
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
      padding: '0 30px'
    },
  })
);

export function SkuInventoryDetails(props: PropsSkusInventoryDetails) {
  const authContext = useContext(AuthContext);

  const classes = useStyles();

  const [openSize, setOpenSize] = React.useState(false as boolean);
  const urlParams = useParams();
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  } as any);

  useEffect(() => {
    getSkusInventory();
    getSkusInventoryFinalizedSum();
    getSkusInventoryNotFinalizedSum();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const getSkusInventory = () => {
    const { skuId } = props.match.params;
    const { page, size } = filtersValues;
    props.getSkusInventoryFinalizedSumDispatch(skuId, {
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  }

  const getSkusInventoryFinalizedSum = () => {
    const { skuId } = props.match.params;
    const { page, size } = filtersValues;
    props.getSkusInventoryNotFinalizedSumDispatch(skuId, {
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  }

  const getSkusInventoryNotFinalizedSum = () => {
    const { skuId } = props.match.params;
    const { page, size } = filtersValues;
    props.getSkusInventoryWithIdDispatch(skuId, {
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  }

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={5} alignItems="center">
        <Grid item xs={12} sm={6}>
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {`
       لیست موجودی  
    ${props.match.params?.name}
     
        `}
            </Typography>
            <span className={classes.contentlabelTitle}>
              {props.match.params?.skuId}
            </span>
          </div>
        </Grid>
      </Grid>

      <Grid>
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
          className={classes.returnButton}
        >
          <RonadIcons name='chevronRight' size={1} />
          {`بازگشت`}
        </Button>
      </Grid>

      {authContext.user.role !== "SELLER_ADMIN" && (
        <Grid className={classes.boxes} container spacing={5}>
          <Grid item xs={4}>
            <div className={classes.box}>
              <div className={classes.allCenter}>
                <RonadIcons
                  name='calendar'
                  size={2}
                  style={{ color: '#5c5c5c', padding: '5px' }}
                />
              </div>
              <div className={classes.title}>در دسترس:</div>
              <div className={classes.text}>{props.availableCount}</div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <div className={classes.box}>
              <div className={classes.activeCenter}>
                <RonadIcons size={2} name='truck' style={{ color: '#039590', padding: '5px' }} />
              </div>
              <div className={classes.title}>در راه انبار:</div>
              <div className={classes.text}>{props.onWayCount}</div>
            </div>
          </Grid>

          <Grid item xs={4}>
            <div className={classes.box}>
              <div className={classes.diactiveCenter}>
                <RonadIcons name="times" size={0.8} className="text-danger"/>
              </div>
              <div className={classes.title}>بازگردانده شده:</div>
              <div className={classes.text}>{props.returnedCount}</div>
            </div>
          </Grid>

        </Grid>
      )}


      <Grid id="showFilter" container item spacing={6}>
        <Grid item xs={12}>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            props.skuInventory && (
              <ListSkuInventoryDetails
                productName={urlParams.name}
                variantId={urlParams.skuId}
                data={props.skuInventory}
                skuId={props.match.params?.skuId}
              />
            )
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {props.skuInventory && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={handleClose}
                className={classes.showCount}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={handleChangeSizePage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {props.skuInventory && (
            <Pagination
              count={Math.ceil(props.skuInventoryCount / filtersValues.size)}
              color="secondary"
              page={filtersValues.page + 1}
              onChange={handleChangePage}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<
  Store,
  SelectorPropsSkusInventoryDetails
>({
  skuInventory: makeSelectSkusInventory(),
  skuInventoryCount: makeSelectSkusInventoryCount(),
  availableCount: makeSelectAvailableCount(),
  onWayCount: makeSelectOnWayCount(),
  returnedCount: makeSelectReturnedCount(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getSkusInventoryWithIdDispatch: (id: number, pagination: object) =>
      dispatch(getSkuInventoryWithIdAction({ id, pagination })),
    getSkusInventoryFinalizedSumDispatch: (id: number, pagination: object) =>
      dispatch(getSkusInventoryFinalizedSumActions({ id, pagination })),
    getSkusInventoryNotFinalizedSumDispatch: (id: number, pagination: object) =>
      dispatch(getSkusInventoryNotFinalizedSumActions({ id, pagination })),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(SkuInventoryDetails);
